import styled from 'styled-components';

export const PriceTableValue = styled.span`
  padding-left: 8px;
  font-family: var(--font-roboto-mono);
  text-align: right;
  display: flex;
  align-items: center;
`;
